export default {
  kameraplaner: {
    intro: {
      badge: 'أداة تخطيط تفاعلية – مجانية وغير ملزمة',
      title: 'خطط لنظام الكاميرات مسبقًا',
      lead:
        'باستخدام مخطط الكاميرات من SSG يمكنك رسم الغرف أو المساحات، وتحديد الأبواب والنوافذ ومناطق المراقبة المهمة، واختبار مواضع الكاميرات المحتملة. تحصل على تقييم بصري أولي يمكن لاحقًا مراجعته فنيًا من قبل SSG Signaltechnik.',
      noReg: 'بدون تسجيل',
      localSave: 'محفوظ محليًا في المتصفح',
      noBinding: 'لا يوجد عدد ملزم للكاميرات',
      quickTitle: 'بدء الفحص السريع',
      quickDesc: 'أجب في خمس خطوات قصيرة عن أسئلة حول العقار ومناطق المراقبة والوظائف المطلوبة. تحصل فورًا على ملخص واضح.',
      quickList: { '0': 'نوع العقار والمناطق المراد مراقبتها', '1': 'الوظائف المطلوبة وبيانات العقار', '2': 'تلخيص النتيجة وإرسالها مباشرة' },
      quickCta: 'بدء الفحص السريع',
      plannerTitle: 'خطط المخطط بنفسك',
      plannerDesc: 'ارسم الغرف والجدران، وضع الأبواب والنوافذ والعوائق والكاميرات – مع مخاريط الرؤية وتحليل التغطية واقتراحات تلقائية للمواضع.',
      plannerList: { '0': 'سطح رسم بشبكة ومقياس بالأمتار', '1': 'مخاريط الرؤية وأهداف المراقبة والمناطق الخاصة', '2': 'رفع المخطط والتقييم والطباعة' },
      plannerCta: 'خطط المخطط بنفسك',
      savedTitle: 'هناك تخطيط محفوظ',
      savedDesc: 'تم حفظه تلقائيًا محليًا ويمكن متابعته.',
      resume: 'متابعة آخر تخطيط',
    },
    quick: {
      steps: { '0': 'نوع العقار', '1': 'المناطق', '2': 'الوظائف', '3': 'بيانات العقار', '4': 'النتيجة' },
      back: 'العودة إلى النظرة العامة',
      title: 'الفحص السريع',
      subtitle: 'خمس خطوات قصيرة – بعدها تحصل على ملخص واضح لتخطيطك الأولي.',
      stepOf: 'الخطوة {{current}} من {{total}}',
      objectQuestion: 'ما نوع العقار المناسب لك؟',
      chooseOne: 'يرجى اختيار خيار.',
      areasQuestion: 'ما المناطق التي يجب مراقبتها؟',
      multiSelect: 'إمكانية الاختيار المتعدد.',
      featuresTitle: 'الوظائف المطلوبة',
      dataTitle: 'بيانات العقار',
      dataOptional: 'جميع البيانات اختيارية ويمكن تخطيها.',
      areaSize: 'المساحة الإجمالية التقريبية (م²)',
      roomCount: 'عدد الغرف أو المناطق',
      inOut: 'داخلي أم خارجي أم كليهما؟',
      inside: 'داخلي',
      outside: 'خارجي',
      both: 'كليهما',
      maxDistance: 'أكبر مسافة مراقبة تقديرية',
      pleaseSelect: 'يرجى الاختيار',
      distanceUpTo5: 'حتى 5 أمتار',
      distance5to10: 'من 5 إلى 10 أمتار',
      distance10to20: 'من 10 إلى 20 مترًا',
      distanceOver20: 'أكثر من 20 مترًا',
      internet: 'هل يتوفر اتصال بالإنترنت؟',
      network: 'هل تتوفر توصيلات الشبكة؟',
      power: 'هل توجد كهرباء عند نقطة التركيب؟',
      yes: 'نعم',
      no: 'لا',
      unknown: 'غير معروف',
      recordingDuration: 'مدة التسجيل المطلوبة',
      installType: 'نظام جديد أم نظام قائم؟',
      newSystem: 'نظام جديد',
      existingSystem: 'نظام قائم',
      existingManufacturer: 'الشركة المصنعة وطراز النظام القائم (إن كان معروفًا)',
      requirements: 'متطلبات خاصة',
      requirementsPlaceholder: 'مثل ظروف إضاءة خاصة أو حماية التراث أو اشتراطات خاصة...',
      chars: '{{current}}/500 حرف',
      ssgCarePre: 'أنا مهتم إضافيًا بـ',
      ssgCarePost: '– الصيانة والرعاية الشخصية للنظام.',
      overviewTitle: 'تخطيطك الأولي في لمحة',
      amberNote: 'استنادًا إلى بياناتك قد تناسب عدة مواضع أو أنواع كاميرات. للحصول على توصية موثوقة يجب فحص زوايا الرؤية وارتفاع التركيب والإضاءة والعوائق الموجودة.',
      planFloorplan: 'خطط المخطط إضافيًا',
      sendToSsg: 'إرسال البيانات إلى SSG',
      editResult: 'تعديل النتيجة',
      backBtn: 'رجوع',
      next: 'التالي',
      summary: {
        objectType: 'نوع العقار',
        areas: 'مناطق المراقبة',
        features: 'الوظائف المطلوبة',
        areaSize: 'المساحة الإجمالية التقريبية',
        roomCount: 'الغرف / المناطق',
        inOut: 'المنطقة',
        maxDistance: 'أكبر مسافة مراقبة',
        internet: 'اتصال الإنترنت',
        network: 'توصيلات الشبكة',
        power: 'الكهرباء عند نقطة التركيب',
        recordingDuration: 'مدة التسجيل',
        installType: 'النظام',
        existingSystem: 'النظام القائم',
        requirements: 'متطلبات خاصة',
        ssgCare: 'رعاية SSG Care',
      },
      values: {
        notSpecified: 'غير محدد',
        inside: 'داخلي',
        outside: 'خارجي',
        inOut: 'داخلي وخارجي',
        present: 'متوفر',
        notPresent: 'غير متوفر',
        unknown: 'غير معروف',
        unclear: 'غير واضح بعد',
        newSystem: 'نظام جديد',
        existing: 'نظام قائم',
        desired: 'مطلوب',
      },
    },
    topbar: {
      projectName: 'اسم المشروع',
      undo: 'تراجع',
      undoTip: 'تراجع (Ctrl+Z)',
      redo: 'إعادة',
      redoTip: 'إعادة (Ctrl+Y)',
      save: 'حفظ مؤقت',
      saved: 'تم الحفظ',
      saveTip: 'حفظ مؤقت',
      reset: 'إعادة تعيين',
      resetTip: 'إعادة تعيين المخطط',
      help: 'مساعدة',
      helpTip: 'فتح المقدمة مرة أخرى',
      evaluate: 'تقييم التخطيط',
      evaluateTip: 'تقييم التخطيط',
    },
    tools: {
      select: { label: 'تحديد', hint: 'نقل العناصر وتغيير حجمها وتدويرها. سحب مساحة فارغة = نقل.' },
      erase: { label: 'حذف', hint: 'حذف العنصر بالنقر.' },
      room: { label: 'غرفة مستطيلة', hint: 'رسم غرفة أو مساحة بالسحب – تُعرض الأبعاد مباشرة.' },
      polygon: { label: 'مساحة حرة', hint: 'رسم مساحة حرة يدويًا: اضغط مع الاستمرار وارسم الشكل.' },
      wall: { label: 'جدار', hint: 'رسم جدار بالسحب – يحد من خطوط الرؤية.' },
      door: { label: 'باب', hint: 'وضع باب على جدار – ثم نقله أو تدويره مباشرة.' },
      window: { label: 'نافذة', hint: 'وضع نافذة على جدار – ثم نقلها أو تدويرها مباشرة.' },
      obstacle: { label: 'عائق', hint: 'رسم عمود أو رف أو حاجز أو كتلة أثاث.' },
      watch: { label: 'هدف مراقبة', hint: 'تحديد منطقة مهمة يجب التقاطها.' },
      privacy: { label: 'منطقة خاصة', hint: 'تحديد منطقة لا يجب التقاطها.' },
      camera: { label: 'كاميرا', hint: 'وضع كاميرا بالنقر. تُفتح قائمة الطرازات يمينًا – الطراز المناسب للمساحة موصى به بالفعل.' },
      text: { label: 'نص', hint: 'إضافة أسماء غرف أو تسميات.' },
    },
    editor: {
      tools: 'الأدوات',
      autoSuggest: 'اقتراحات تلقائية',
      analysis: 'تحليل التغطية',
      properties: 'الخصائص',
      backToIntro: 'العودة إلى نظرة عامة لمخطط الكاميرات',
      resetTitle: 'إعادة تعيين المخطط؟',
      resetText: 'سيتم حذف جميع العناصر المرسومة والكاميرات والمخطط المرفوع نهائيًا. ستتم إزالة التخطيط المحفوظ.',
      cancel: 'إلغاء',
      confirmReset: 'نعم، أعد التعيين',
      close: 'إغلاق',
      openTools: 'فتح الأدوات',
      openAnalysis: 'فتح التحليل',
      snap: 'تفعيل/تعطيل الالتقاط بالشبكة',
      zoomIn: 'تكبير',
      zoomOut: 'تصغير',
      fit: 'توسيط المخطط',
      closeHints: 'إغلاق التلميحات',
    },
    canvas: {
      areaLabel: 'سطح رسم المخطط',
      calibHint: 'يرجى تحديد مسافة للمعايرة',
      locked: 'مقفل',
      scale: 'المقياس: حوالي {{px}} بكسل/م · الشبكة {{step}} م',
      calibNotice: 'انقر على نقطتين في المخطط تعرف المسافة بينهما.',
    },
    props: {
      edit: 'تعديل الخصائص',
      delete: 'حذف',
      cameraModel: 'طراز الكاميرا (جهاز حقيقي)',
      nameNumber: 'الاسم / الرقم',
      cameraCategory: 'فئة الكاميرا',
      modelAssigned: 'تم تعيين الطراز "{{series}}".',
      planningValues: 'هذه قيم تخطيطية – وليست بيانات فنية لمنتج حقيقي.',
      visibility: 'الرؤية',
      recognition: 'التعرف',
      detail: 'التفاصيل',
      rotation: 'الاتجاه (°)',
      fov: 'زاوية الرؤية (°)',
      range: 'المدى (م)',
      posX: 'الموضع X (م)',
      posY: 'الموضع Y (م)',
      mountHeight: 'ارتفاع التركيب (م)',
      indoor: 'داخلي',
      outdoor: 'خارجي',
      usage: 'مجال الاستخدام',
      dayNight: 'نهار / ليل',
      target: 'هدف المراقبة المطلوب',
      noneAssigned: 'لم يتم تعيين أي هدف',
      targetArea: 'المنطقة المستهدفة',
      remark: 'ملاحظة',
      remarkPlaceholder: 'مثل ملاحظات حول التركيب أو المحيط...',
      coneNote: 'مخروط الرؤية هو تمثيل تخطيطي. تعتمد جودة الصورة الفعلية على الطراز والعدسة والمسافة وارتفاع التركيب والإضاءة والعوائق في الموقع.',
      roomLabel: 'تسمية الغرفة',
      length: 'الطول (م)',
      width: 'العرض (م)',
      area: 'المساحة: حوالي {{area}} م²',
      designation: 'التسمية',
      points: '{{count}} نقاط – حرّك النقاط مباشرة على سطح الرسم.',
      wallThickness: 'سماكة الجدار (م)',
      wallLength: 'الطول: حوالي {{length}} م',
      wallNote: 'الجدران الصلبة تحد من خطوط الرؤية في المخطط.',
      obstacleKind: 'نوع العائق',
      shape: 'الشكل',
      rect: 'مستطيل',
      circle: 'دائرة',
      caption: 'التسمية',
      diameter: 'القطر (م)',
      depth: 'العمق (م)',
      goalKind: 'نوع الهدف',
      priority: 'الأولوية',
      goal: 'الهدف المطلوب',
      coverageNote: 'تُقيَّم التغطية بالألوان (أخضر / أصفر / أحمر). تنطبق متطلبات أكثر صرامة على أهداف التفاصيل.',
      zoneKind: 'نوع المنطقة',
      privacyNote: 'إذا تداخل مخروط رؤية مع هذه المنطقة، يظهر تحذير في التحليل.',
      textContent: 'محتوى النص',
      duplicate: 'تكرار',
      deleteElement: 'حذف العنصر',
      projectData: 'بيانات المشروع',
      noElement: 'لم يتم تحديد أي عنصر',
      projectName: 'اسم المشروع',
      objectType: 'نوع العقار',
      objectTypePlaceholder: 'مثل منزل عائلة واحدة',
      projectDescription: 'وصف المشروع',
      projectDescriptionPlaceholder: 'الخصوصيات أو الرغبات أو الشروط العامة...',
      maxChars: 'بحد أقصى 500 حرف',
      cameraForNew: 'طراز الكاميرا للكاميرات الجديدة',
      cameraForNewDesc: 'اختر أدناه طراز Safire المطلوب – تُفتح القائمة المنسدلة تلقائيًا. تُوضع الكاميرات الجديدة بهذه الإعدادات.',
      recommendedFor: 'موصى به لمساحتك:',
      orGeneric: 'أو فئة عامة',
      tips: 'نصائح',
      tip1: 'سحب مساحة فارغة بأداة التحديد = تحريك سطح العمل. عجلة الفأرة = تكبير.',
      tip2: 'Ctrl+Z = تراجع، Ctrl+Y = إعادة، حذف = حذف العنصر.',
      tip3: 'يمكن تفعيل/تعطيل الالتقاط بالشبكة في خيارات العرض.',
      suggestPositions: 'اقتراح مواضع الكاميرات تلقائيًا',
      doorSwing: 'اتجاه الفتح',
      left: 'يسار',
      right: 'يمين',
      none: 'لا شيء',
      attached: 'موضوع على جدار – اسحب على طول الجدار للتحريك. عند الدوران يُحرَّر العنصر.',
      detached: 'موضوع بحرية – حرّكه ودوّره بحرية.',
      doorNote: 'يجب فحص الخامة والزجاج وحالة الفتح في الموقع.',
    },
    result: {
      edit: 'تعديل التخطيط',
      print: 'طباعة الملخص',
      savePdf: 'حفظ كـ PDF',
      send: 'إرسال التخطيط إلى SSG',
      eyebrow: 'التقييم',
      title: 'تخطيطك الأولي في لمحة',
      disclaimer: 'هذا التقييم تخطيط أولي غير ملزم. لا تُقدَّم توصية نهائية إلا بعد فحص الظروف المحلية واختيار تقنية الكاميرا المناسبة.',
      project: 'المشروع',
      objectType: 'نوع العقار:',
      uploadPresent: 'رفع المخطط متاح:',
      scaled: 'تمت المعايرة',
      refDistance: 'م مسافة مرجعية',
      notScaled: 'لم تتم المعايرة بعد',
      createdAt: 'أُنشئ في',
      floorplan: 'المخطط المرسوم',
      noElements: 'لا توجد عناصر في المخطط بعد.',
      stats: { rooms: 'الغرف والمساحات', walls: 'الجدران', doors: 'الأبواب', windows: 'النوافذ', obstacles: 'العوائق', cameras: 'الكاميرات', zones: 'المناطق المستهدفة', privacy: 'المناطق الخاصة' },
      zonesTitle: 'أهداف المراقبة والأولويات',
      noZones: 'لم يتم تحديد أي أهداف مراقبة.',
      priorityLabel: 'الأولوية',
      goalLabel: 'الهدف',
      goalOverview: 'نظرة عامة',
      goalDetail: 'تفاصيل',
      goalObservation: 'مراقبة',
      coverage: 'تغطية هندسية',
      camerasTitle: 'مواضع وأنواع الكاميرات',
      noCameras: 'لم يتم وضع أي كاميرات بعد.',
      modelLabel: 'الطراز',
      fovLabel: 'زاوية الرؤية',
      visibilityLabel: 'الرؤية تقريبًا',
      recognitionLabel: 'التعرف تقريبًا',
      detailLabel: 'التفاصيل تقريبًا',
      positionLabel: 'الموضع',
      rotationLabel: 'الاتجاه',
      rangeLabel: 'المدى تقريبًا',
      mountLabel: 'ارتفاع التركيب',
      indoor: 'داخلي',
      outdoor: 'خارجي',
      day: 'نهار',
      night: 'ليل',
      dayNight: 'نهار وليل',
      target: 'الهدف',
      assigned: 'معيّن',
      modelNote: 'تعتمد طرازات Safire المختارة على قيم كتيب البيانات؛ الرؤية/التعرف/التفاصيل هي قيم تخطيطية محسوبة (EN 62676-4). بدون طراز تكون القيم عامة – وليست بيانات فنية لمنتج حقيقي.',
      blindTitle: 'نقاط عمياء محتملة ونقاط مفتوحة',
      uncovered: 'مناطق غير مغطاة بشكل كافٍ:',
      privacyOverlaps: 'تداخلات مع المناطق الخاصة:',
      checkPrivacy: 'افحص الموضع أو الاتجاه أو الإخفاء.',
      missingTitle: 'بيانات مهمة مفقودة',
      quickTitle: 'الوظائف المطلوبة وبيانات العقار',
      areasLabel: 'المناطق:',
      featuresLabel: 'الوظائف:',
      areaLabel: 'المساحة:',
      recordingLabel: 'التسجيل:',
      internetLabel: 'الإنترنت:',
      powerLabel: 'الكهرباء:',
      careInterest: 'الاهتمام برعاية SSG Care',
      finalNote: 'سيُراجع التخطيط فنيًا من قبل SSG Signaltechnik. ارتفاع التركيب والإضاءة والزوايا وظروف الموقع تحدد التنفيذ النهائي.',
      sendBottom: 'إرسال التخطيط إلى SSG Signaltechnik',
      consult: 'طلب استشارة شخصية',
      good: 'مغطى جيدًا',
      partial: 'مغطى جزئيًا',
      insufficient: 'غير كافٍ',
    },
    send: {
      back: 'رجوع',
      title: 'إرسال التخطيط إلى SSG Signaltechnik',
      lead: 'تُرسل بيانات التخطيط (المخطط والكاميرات وزوايا الرؤية وأهداف المراقبة والمناطق الخاصة ونتيجة التحليل) مع بيانات الاتصال الخاصة بك. بيانات الاتصال مطلوبة الآن فقط – يبقى التخطيط محليًا على جهازك.',
      dataTitle: 'بيانات التخطيط المرسلة',
      floorplan: 'المخطط',
      rooms: 'الغرف/المساحات',
      walls: 'الجدران',
      doors: 'الأبواب',
      windows: 'النوافذ',
      obstacles: 'العوائق',
      cameras: 'الكاميرات',
      none: 'لا شيء',
      zones: 'أهداف المراقبة',
      privacy: 'المناطق الخاصة',
      analysis: 'التحليل',
      good: 'جيد',
      partial: 'جزئي',
      insufficient: 'غير مغطى بشكل كافٍ',
      upload: 'رفع المخطط',
      scaled: 'تمت المعايرة',
      notScaled: 'لم تتم المعايرة',
      customerType: 'عميل خاص أم تجاري *',
      privateCustomer: 'عميل خاص',
      businessCustomer: 'عميل تجاري',
      name: 'الاسم الأول والأخير *',
      company: 'الشركة (اختياري)',
      phone: 'رقم الهاتف',
      email: 'عنوان البريد الإلكتروني *',
      projectAddress: 'عنوان المشروع',
      projectAddressPlaceholder: 'الشارع، الرمز البريدي، المدينة',
      contactPref: 'طريقة الاتصال المفضلة',
      any: 'لا يهم',
      byPhone: 'الهاتف',
      byEmail: 'البريد الإلكتروني',
      callbackTime: 'الفترة المفضلة لمعاودة الاتصال',
      noCallback: 'لا أرغب في معاودة الاتصال',
      morning: 'صباحًا',
      afternoon: 'بعد الظهر',
      evening: 'مساءً',
      systemStatus: 'نظام جديد أم قائم',
      newSystem: 'نظام جديد',
      existingSystem: 'نظام قائم',
      unsure: 'غير متأكد بعد',
      existingManufacturer: 'الشركة المصنعة لنظام قائم (إن كان معروفًا)',
      existingManufacturerPlaceholder: 'مثل Hikvision أو Safire...',
      careInterest: 'الاهتمام بـ SSG Care',
      careYes: 'نعم، يرجى إعلامي',
      careNo: 'لا',
      careLater: 'القرار لاحقًا',
      message: 'رسالة إضافية',
      messagePlaceholder: 'إضافات إلى تخطيطك...',
      fileUpload: 'المخطط / الصور (اختياري)',
      fileNote: 'ملاحظة: تُعامل رفعات الملفات كـ "Uncollectable" – تُرسل بيانات التخطيط كنص.',
      privacyConsent: 'لقد قرأت سياسة الخصوصية وأوافق على معالجة بياناتي لمعالجة هذا الطلب. تُستخدم بيانات التخطيط حصريًا للمعالجة. *',
      privacyLink: 'سياسة الخصوصية',
      error: 'حدث خطأ. يرجى المحاولة لاحقًا.',
      networkError: 'خطأ في الشبكة. يرجى التحقق من اتصالك والمحاولة مرة أخرى.',
      successTitle: 'شكرًا لك على تخطيطك.',
      successText: 'سيراجع SSG Signaltechnik بياناتك وسيتواصل معك شخصيًا.',
      sending: 'جارٍ الإرسال...',
      submit: 'إرسال التخطيط إلى SSG',
      backToResult: 'العودة إلى التقييم',
    },
    tour: {
      stepOf: 'الخطوة {{current}} من {{total}}',
      skip: 'تخطي',
      back: 'رجوع',
      next: 'التالي',
      finish: 'هيا بنا',
      dialogLabel: 'مقدمة مخطط الكاميرات',
      steps: {
        '0': { title: 'مرحبًا بك في مخطط الكاميرات SSG', text: 'ارسم غرفتك أو ارفع مخططًا.' },
        '1': { title: 'تحديد المناطق', text: 'حدد الأبواب والنوافذ والمناطق المهمة.' },
        '2': { title: 'وضع الكاميرات', text: 'ضع الكاميرات أو اطلب اقتراح المواضع.' },
        '3': { title: 'فحص مجالات الرؤية', text: 'افحص مجالات الرؤية والنقاط العمياء المحتملة.' },
        '4': { title: 'إرسال التخطيط', text: 'أرسل التخطيط الأولي إلى SSG Signaltechnik.' },
      },
    },
    analysis: {
      title: 'تحليل التغطية',
      suggest: 'اقتراح المواضع',
      suggestTip: 'اقتراح مواضع الكاميرات',
      cameras: 'الكاميرات',
      zones: 'المناطق المستهدفة',
      good: 'مغطى جيدًا',
      partial: 'جزئي',
      notCovered: 'غير مغطى',
      privacyConflict: 'تعارض منطقة خاصة',
      areaCoverage: 'التغطية الهندسية للمساحة',
      areaNote: 'تغطية ممثلة هندسيًا – لا تعبر عن جودة الصورة أو التعرف الفعلية.',
      legend: 'وسيلة الإيضاح',
      legendFov: 'مجال رؤية الكاميرا',
      legendDetail: 'تعرف تفاصيل حاد (متقطع)',
      legendGood: 'الهدف مغطى جيدًا',
      legendPartial: 'الهدف مغطى جزئيًا',
      legendBad: 'الهدف غير كافٍ',
      legendPrivacy: 'منطقة خاصة / مستبعدة',
      note: 'تقييم الألوان هو توجيه هندسي. زاوية الرؤية الواسعة لا تعني تلقائيًا تعرفًا كافيًا على التفاصيل – يجب فحص المسافة والدقة وارتفاع التركيب.',
    },
    upload: {
      title: 'رفع المخطط',
      desc: 'اختياري: ارفع مخططًا موجودًا (JPG أو PNG أو WebP) كخلفية. ثم حدد مسافة معروفة وأدخل طولها ليتم قياس المخطط بشكل صحيح.',
      choose: 'اختيار المخطط',
      chooseOther: 'اختيار صورة أخرى',
      remove: 'إزالة',
      calibPrompt: 'انقر الآن على النقطة A والنقطة B في المخطط على سطح الرسم.',
      startCalib: 'بدء المعايرة',
      scaled: 'تمت المعايرة: {{cm}} سم لكل بكسل · المسافة {{m}} م',
      lengthPlaceholder: 'الطول بالأمتار',
      apply: 'تطبيق',
      opacity: 'الشفافية {{pct}} %',
      lock: 'قفل الخلفية (يمنع التحريك العرضي)',
      moveHint: 'للتحريك: اسحب مكانًا فارغًا في الصورة بأداة التحديد (إذا لم تكن مقفلة).',
      privacyNote: 'قد تحتوي المخططات وصور العقار على معلومات حساسة. ارفع فقط الملفات اللازمة لمعالجة طلبك.',
      onlyImages: 'يرجى اختيار صور JPG أو PNG أو WebP فقط.',
      tooLarge: 'الملف كبير جدًا. يرجى اختيار صورة أقل من 8 ميغابايت.',
      readError: 'تعذر قراءة الملف.',
      validLength: 'يرجى إدخال طول صالح بالأمتار.',
      tooClose: 'النقاط المحددة قريبة جدًا من بعضها.',
    },
    picker: {
      generic: 'اختيار فئة عامة',
      genericOption: 'فئة عامة (بدون طراز)',
      recommended: 'موصى به',
      recommendation: 'توصية لمساحتك',
      fovLabel: 'زاوية الرؤية',
      detailFrom: 'التفاصيل من حوالي {{detail}} م · التعرف حوالي {{recognition}} م',
      hFov: 'زاوية الرؤية الأفقية',
      vFov: 'زاوية الرؤية العمودية',
      resolution: 'الدقة',
      lens: 'العدسة',
      irRange: 'مدى الأشعة تحت الحمراء',
      ipClass: 'فئة الحماية',
      audio: 'الصوت',
      dayNight: 'نهار / ليل',
      datenblatt: 'كتيب البيانات',
      planungswert: 'قيمة تخطيطية',
      doriNote: 'الرؤية/التعرف/التفاصيل: قيم تخطيطية محسوبة وفق EN 62676-4 (كثافة البكسل). تعتمد جودة الصورة الفعلية على الطراز والعدسة وارتفاع التركيب والإضاءة والعوائق في الموقع.',
      groups: { standard: 'قياسي / داخلي وخارجي', outdoor: 'خارجي', panorama180: 'بانوراما', ptz: 'تحريك / تكبير' },
    },
    quickswitch: {
      title: 'تغيير طراز الكاميرا',
      subtitle: 'تبديل الطراز مباشرة',
      active: 'نشط',
      recommended: 'موصى به',
      note: 'اضبط الاتجاه والمدى وارتفاع التركيب في لوحة الخصائص اليمنى.',
      close: 'إغلاق اختيار الطراز',
    },
    elementTypes: {
      room: 'غرفة / مساحة',
      polygon: 'مساحة حرة',
      wall: 'جدار',
      door: 'باب',
      window: 'نافذة',
      obstacle: 'عائق',
      watchzone: 'هدف مراقبة',
      privacy: 'منطقة خاصة / استثناء',
      camera: 'كاميرا',
      text: 'نص',
    },
    defaults: { room: 'غرفة', watchzone: 'منطقة هدف', text: 'اسم الغرفة' },
    defaultProject: 'تخطيط الكاميرات الخاص بي',
    quickProject: 'تخطيط الكاميرات (فحص سريع)',
    options: {
      objectTypes: {
        Einfamilienhaus: 'منزل عائلة واحدة',
        Mehrfamilienhaus: 'عمارة سكنية',
        Wohnung: 'شقة',
        'Ladengeschäft': 'متجر',
        'Büro oder Praxis': 'مكتب أو عيادة',
        Gastronomie: 'مطاعم ومقاهي',
        'Lager oder Logistik': 'مستودع أو لوجستيات',
        Werkstatt: 'ورشة',
        'Parkplatz oder Außenfläche': 'موقف سيارات أو مساحة خارجية',
        Baustelle: 'موقع بناء',
        Sonstiges: 'أخرى',
      },
      areas: {
        Haupteingang: 'المدخل الرئيسي',
        Nebeneingang: 'المدخل الجانبي',
        Fenster: 'نافذة',
        Einfahrt: 'المدخل',
        Garage: 'المرآب',
        'Garten oder Terrasse': 'حديقة أو شرفة',
        Kasse: 'الخزينة',
        Verkaufsfläche: 'مساحة البيع',
        Lager: 'المستودع',
        Lieferzone: 'منطقة التسليم',
        Parkplatz: 'موقف السيارات',
        'Büro oder Innenraum': 'مكتب أو مساحة داخلية',
        'Gesamte Außenfläche': 'المساحة الخارجية بالكامل',
        'Sonstiger Bereich': 'منطقة أخرى',
      },
      features: {
        'Live-Ansicht': 'عرض مباشر',
        'lokale Aufzeichnung': 'تسجيل محلي',
        'Smartphone-Zugriff': 'وصول من الهاتف',
        'Wiedergabe gespeicherter Aufnahmen': 'تشغيل التسجيلات المحفوظة',
        Ereignisbenachrichtigungen: 'إشعارات الأحداث',
        'gute Sicht bei Dunkelheit': 'رؤية جيدة في الظلام',
        'Übersicht über eine große Fläche': 'نظرة عامة على مساحة كبيرة',
        'Erkennung wichtiger Details': 'التعرف على تفاصيل مهمة',
        'mehrere Benutzer': 'عدة مستخدمين',
        'mehrere Standorte': 'عدة مواقع',
        'vorhandene Anlage erweitern': 'توسيع النظام القائم',
        'SSG-Care-Betreuung': 'رعاية SSG Care',
      },
      recordingDurations: {
        'Bis 7 Tage': 'حتى 7 أيام',
        'Bis 14 Tage': 'حتى 14 يومًا',
        'Bis 30 Tage': 'حتى 30 يومًا',
        'Mehr als 30 Tage': 'أكثر من 30 يومًا',
        'noch unklar': 'غير واضح بعد',
      },
      roomNames: {
        Eingang: 'مدخل',
        Flur: 'ممر',
        Wohnzimmer: 'غرفة المعيشة',
        'Büro': 'مكتب',
        Verkaufsfläche: 'مساحة البيع',
        Kasse: 'الخزينة',
        Lager: 'المستودع',
        Werkstatt: 'الورشة',
        Parkplatz: 'موقف السيارات',
        Außenbereich: 'منطقة خارجية',
      },
      obstacles: {
        saeule: 'عمود',
        regal: 'رف',
        trennwand: 'حاجز مرتفع',
        moebel: 'كتلة أثاث',
        fahrzeug: 'موقف مركبة',
        eigen: 'عائق مسمى',
      },
      watchKinds: {
        ueberblick: 'الإشراف الكامل على المنطقة',
        eingang: 'مراقبة المدخل',
        tuer: 'مراقبة الباب',
        fenster: 'مراقبة النافذة',
        kasse: 'التقاط الخزينة أو نقطة حساسة',
        zufahrt: 'مراقبة المدخل',
        kennzeichen: 'فحص منطقة اللوحات',
        flaeche: 'نظرة عامة على مساحة',
        details: 'التعرف على تفاصيل مهمة',
        individuell: 'منطقة فردية',
      },
      watchPriorities: { normal: 'عادي', wichtig: 'مهم', kritisch: 'حرج' },
      watchGoals: { uebersicht: 'نظرة عامة', beobachtung: 'مراقبة', detail: 'تفاصيل' },
      privacyKinds: {
        privat: 'منطقة خاصة',
        nachbar: 'عقار الجار',
        oeffentlich: 'رصيف أو شارع عام',
        mitarbeiter: 'منطقة الموظفين',
        ausgeschlossen: 'منطقة لا يجب التقاطها',
      },
      categories: {
        standard: { label: 'كاميرا قياسية', hint: 'متعددة الاستخدامات للداخل والخارج' },
        wide: { label: 'كاميرا واسعة الزاوية', hint: 'نظرة واسعة على مسافة قصيرة إلى متوسطة' },
        varifocal: { label: 'كاميرا بزاوية متغيرة', hint: 'تُضبط الزاوية في الموقع' },
        panorama180: { label: 'كاميرا بانورامية 180°', hint: 'التقاط واسع جدًا، التعرف على التفاصيل محدود' },
        fisheye360: { label: 'كاميرا 360° / عين السمكة', hint: 'رؤية شاملة، تُصحَّح الصورة إلكترونيًا' },
        ptz: { label: 'كاميرا PTZ', hint: 'كاميرا تحريك/إمالة/تكبير للمساحات الأكبر' },
        indoor: { label: 'كاميرا داخلية', hint: 'مُحسَّنة للداخل' },
        outdoor: { label: 'كاميرا خارجية', hint: 'نسخة مقاومة للعوامل الجوية للخارج' },
      },
      dayNight: { tag: 'نهار', nacht: 'ليل', beides: 'نهار وليل' },
    },
    models: {
      'safire-turret-i1-4mp': { ai: 'تصنيف الأشخاص والمركبات (AI)', note: 'كاميرا Turret متعددة الاستخدامات بزاوية رؤية واسعة – معيار جيد للداخل والخارج.' },
      'safire-turret-e1-4mp': { ai: 'تصنيف الأشخاص والمركبات (AI)', note: 'طراز اقتصادي للمبتدئين من سلسلة E1 بدقة جيدة.' },
      'safire-turret-b1-4mp': { ai: '', note: 'كاميرا Turret اقتصادية قوية بهيكل مقاوم للصدمات (IK10).' },
      'safire-dome-i2-8mp': { ai: 'تصنيف الأشخاص والمركبات (AI)', note: 'دقة عالية 8 ميجابكسل – تفاصيل أكثر في نفس الإطار.' },
      'safire-bullet-4mp': { ai: 'تصنيف الأشخاص والمركبات (AI)', note: 'تصميم Bullet كلاسيكي للتركيب الخارجي. زاوية الرؤية كقيمة تخطيطية وفق السلسلة.' },
      'safire-turret-nightcolor-4mp': { ai: 'صورة ملونة في الظلام (NightColor X)', note: 'توفر صورة ملونة حتى في الإضاءة المنخفضة – مثالية للحالات الليلية الحرجة. زاوية الرؤية كقيمة تخطيطية.' },
      'safire-turret-duallight-4mp': { ai: 'تصنيف الأشخاص والمركبات (AI)', note: 'DualLight بمصابيح LED تحت حمراء وضوء أبيض (30 م لكل منهما) – مرنة ليلًا. زاوية الرؤية كقيمة تخطيطية.' },
      'safire-panorama-180-8mp': { ai: 'رؤية بانورامية 180° مع مكبر صوت وميكروفون', note: 'تلتقط مساحة واسعة جدًا بكاميرا واحدة – التعرف على التفاصيل عن بُعد محدود.' },
      'safire-miniptz-4mp': { ai: 'تتبع تلقائي، تصنيف الأشخاص والمركبات', note: 'كاميرا PTZ بتتبع تلقائي. زاوية الرؤية كقيمة تخطيطية (الوضع النهائي واسع الزاوية).' },
      'safire-ptz-15x-2mp': { ai: 'تتبع تلقائي، تتبع السيارات والمركبات', note: 'مدى كبير بفضل تكبير 15× وأشعة تحت حمراء 200 م. زاوية الرؤية كقيمة تخطيطية (الوضع النهائي واسع الزاوية).' },
    },
    disclaimer: {
      general: 'يوفر مخطط الكاميرات تخطيطًا أوليًا غير ملزم. يعتمد إطار الصورة الفعلي وموضع الكاميرا المناسب على الطراز والعدسة والمسافة وارتفاع التركيب والإضاءة والعوائق وظروف الموقع.',
      result: 'هذا التقييم تخطيط أولي غير ملزم. لا تُقدَّم توصية نهائية إلا بعد فحص الظروف المحلية واختيار تقنية الكاميرا المناسبة.',
      upload: 'قد تحتوي المخططات وصور العقار على معلومات حساسة. ارفع فقط الملفات اللازمة لمعالجة طلبك.',
      sichtfeld: 'قد تؤثر الأبواب والنوافذ على خطوط الرؤية. يجب فحص الخامة والزجاج وحالة الفتح وانعكاس الضوء في الموقع.',
      datenschutz: 'بالنسبة لمتطلبات مثل التعرف على الوجه أو تحديد الأشخاص أو التعرف على اللوحات، يلزم فحص تقني وفحص لحماية البيانات.',
    },
    hints: {
      '0': 'استنادًا إلى بياناتك قد تناسب عدة مواضع أو أنواع كاميرات. للحصول على توصية موثوقة يجب فحص زوايا الرؤية وارتفاع التركيب والإضاءة والعوائق الموجودة.',
      '1': 'زاوية الرؤية الواسعة لا تعني تلقائيًا تعرفًا كافيًا على التفاصيل. المسافة والدقة والزاوية وارتفاع التركيب والهدف تؤثر على جودة الصورة الفعلية.',
      '2': 'يجب فحص ارتفاع التركيب وظروف الإضاءة في الموقع.',
    },
    recommend: {
      noArea: 'توصية قياسية ما دامت لم تُرسم أي مساحة بعد. ارسم غرفتك وستتكيف التوصية.',
      veryLarge: 'مساحة كبيرة جدًا (حوالي {{area}} م²) – PTZ مع تكبير ومدى كبير للمسافات الواسعة.',
      large: 'مساحة كبيرة (حوالي {{area}} م²) – تصميم Bullet قوي للخارج.',
      medium: 'مساحة متوسطة إلى كبيرة (حوالي {{area}} م²) – 8 ميجابكسل لمزيد من التفاصيل في العرض.',
      compact: 'مساحة صغيرة (حوالي {{area}} م²) – زاوية رؤية واسعة تغطي الغرفة جيدًا.',
    },
    analysisDynamic: {
      missingNoCameras: 'لم يتم وضع أي كاميرات بعد.',
      missingNoRooms: 'لم تُرسم أي غرف أو مساحات بعد.',
      missingNoWalls: 'لم تُرسم جدران – مخاريط الرؤية غير محدودة.',
      missingNoZones: 'لم يتم تحديد أي أهداف مراقبة.',
      missingNoPrivacy: 'لم يتم تحديد أي مناطق خاصة أو مستبعدة.',
      missingNoInternet: 'معلومات اتصال الإنترنت مفقودة.',
      missingNoPower: 'معلومات التغذية الكهربائية مفقودة.',
      hintUncovered: 'مناطق مستهدفة بدون تغطية كافية: افحص مواضع الكاميرات أو خطط لكاميرات إضافية.',
      hintPartial: 'بعض المناطق المستهدفة مغطاة جزئيًا فقط – عدّل الزاوية أو الموضع أو المدى.',
      hintDetailRange: 'مدى التفاصيل لـ "{{name}}" (حوالي {{range}} م) على الأرجح لا يكفي وحده للغرف الكبيرة – قد تكون كاميرا إضافية مفيدة.',
      hintPrivacy: 'يتداخل مجال الرؤية مع منطقة خاصة محددة. يجب فحص موضع الكاميرا أو اتجاهها أو الإخفاء التقني.',
      hintMount: 'يجب فحص ارتفاع التركيب وظروف الإضاءة في الموقع.',
      hintKennzeichen: 'يلزم فحص تقني وفحص لحماية البيانات.',
      noteDetailRange: 'التعرف على التفاصيل على الأرجح غير كافٍ لمسافة حوالي {{distance}} م – التفاصيل القصوى حوالي {{identification}} م. يجب فحص زاوية أضيق أو طراز بدقة أعلى.',
      noteDetailUncertain: 'التعرف على التفاصيل على مسافات أكبر غير مؤكد – يجب فحص زاوية أضيق وارتفاع التركيب.',
      notePartial: 'قد تكون هذه المنطقة مغطاة جزئيًا فقط.',
      suggestNear: 'هدف المراقبة "{{target}}" قريب من "{{privacy}}". يجب اختيار الموضع والاتجاه بعناية – يلزم فحص لحماية البيانات.',
      suggestHeuristic: 'الاقتراحات استدلالية. يمكن تحريك كل كاميرا أو تدويرها أو تغييرها أو حذفها بحرية.',
      suggestWide: 'زاوية الرؤية الواسعة لا تعني تعرفًا كافيًا على التفاصيل. المسافة والدقة وارتفاع التركيب تؤثر على جودة الصورة.',
      cameraNoteDetail: 'أول موضع كاميرا محتمل – خطط لزاوية أضيق لأهداف التفاصيل.',
      cameraNoteCheck: 'أول موضع كاميرا محتمل – يرجى الفحص والتعديل.',
      cameraSuggestion: 'اقتراح {{count}}',
      uncoveredPartial: 'جزئي',
      uncoveredInsufficient: 'غير كافٍ',
      toastNoPositions: 'لم يتم العثور على مواضع جديدة. أضف أهداف مراقبة أو غرفًا.',
      toastSuggested: 'تم اقتراح {{count}} موضع/مواضع كاميرا محتمل/محتملة.',
    },
  },
};